module.exports = __webpack_public_path__ + "static/media/BeaconLogo@2x.06b59cc1.png";